// import '@interactjs/auto-start'
// import '@interactjs/actions/drag'
// import '@interactjs/actions/resize'
// import '@interactjs/modifiers'
// import '@interactjs/dev-tools'
import interact from 'interactjs'


var tlBtnsSuggest = new TimelineMax({paused:true, onReverseComplete: trashBtns});
var tlMessages = new TimelineMax({paused:true });
var tlBot = new TimelineMax({paused:true, reversed : true})
var tlAnimPulse = new TimelineMax({repeat: -1, repeatDelay: 3});
const ficheTimeline = new TimelineMax({ paused : true, onReverseComplete : clearFicheProps, onComplete: openFicheProps });

var runningSetTimeout = [];

function clearFicheProps() {   
    $('body').removeClass('has-user-gesture')  
    TweenLite.set('.sidebar-search .tab-content', {y: -25});
}

function openFicheProps() {
    $('body').addClass('has-user-gesture')  
}


class BotManager {
    constructor() {
        //opts
        // Si tu veux qu'on se fasse une petite gestion avec des options mouahaha<
        // this.options = Object.assign({}, opts);

        this.elements = {
            isWaiting : $('.is-waiting'),
            ui_skitt : $('#skitt-ui'),
            form_search : $('#js-form-search'),
            tchatbot_box : $('.area-tchatbot'),
            tchatFooter : $('.area-tchatbot-footer'),
            area_message : $('.area-tchatbot-inner'),
            tchatbot_message : $('.tchatbot-message'),
            result_search : $('#js-result-search'),
            nb_results: $('#js-nb-resultats'),
            tabsItems: $('.js-sidebar-search-link'),
            tabsItemsPane: $('.tab-pane-custom')
        }
        this.label_message = 'bot',
        this.labels = {
            asUserRequest : false
        },
        this.first_message = true,
        this.tpl_message = '',
        this.timerScroll = 800,
        this.intTrashBtns = 0;
    }
    traiteReponse(infoReponse) {
        // console.log('infoReponse', infoReponse)
        switch (infoReponse['action']) {
            case 'retour_bot':
                this.createResponseFromBot(infoReponse, {'default-response': true})
                break;
            case 'retour_bot_alert':
                this.createResponseFromBot(infoReponse, {'default-response': true})
                break;
            case 'result_html':
                // Je veux acheter un matelas
                this.createResponseFromBot(infoReponse, {'html': true})
                break;
            case 'redirect':
                // je veux vendre une chaise de petit volume
                this.createResponseFromBot(infoReponse, {'redirect': true})
                break;
            case 'set_nb_result':
                $('#js-nb-resultats').html(infoReponse.result);
                break;
            case 'replace_form':
                // On modifie les informations du formulaire pour pouvoir repasser sur une recherche manuelle
                var infoForm = $.parseJSON(infoReponse.result);
                $.each(infoForm,function(key,ssinfoReponse){

                    var element = $( "[name='"+key+"']" );
                    // Gestion particuliere des categories
                    if(key==="categ"){
                        var elementOption = element.children("option[value='"+ssinfoReponse+"']").first();
                        if(!elementOption.length){
                            return; // Equivalent du continue en JQuery
                        }
                    }
                    // On passe la valeur
                    if(element.is(':checkbox')){
                        element.prop('checked', true);
                    } else {
                        element.val(ssinfoReponse);
                    }
                });
                break;
            case 'close':
                annyang.abort();
                break;
            default:
                //console.log('Action non connue : '+infoReponse['action']);
                break;
        }
    }
    formatMessage(infoReponse) {
        var classe_css;
        var text;
        var messageFormated = '';
        infoReponse.result && infoReponse.result.length > 0 ? text = infoReponse.result : text = infoReponse
        this.first_message === true ? classe_css = 'first-message' : classe_css = '';
        messageFormated += '<div style="opacity:0;" class="tchatbot-message '+this.label_message +' '+ classe_css +'">'+ text +'</div>';
        if(this.label_message === 'user') {
            var dateWithouthSecond = new Date();
            var date_final = dateWithouthSecond.toLocaleTimeString(navigator.language, {hour: '2-digit', minute:'2-digit'});
            messageFormated += '<div style="opacity:0;" class="tchatbot-message user-time-message '+ classe_css +'">'+ date_final +'</div>';
        }
        this.tpl_message = messageFormated
    }

    createAndAttchPrompts(infoReponse) {
        var arrProps;
        infoReponse.propositions && infoReponse.propositions.length > 0 ? arrProps = infoReponse.propositions : arrProps = infoReponse
        let btns = '';
        arrProps.forEach((props) => {
            // le data response est une suggestion pour toi mon cher Leo !
            btns += '<a class="btn btn-black js-response-user" style="opacity:0;" data-response="'+ props +'" href="#">'+ props +'</a>'
        })
        this.elements.tchatFooter.append(btns);
        tlBtnsSuggest.to(this.elements.tchatFooter, .2, {className : '+=has-suggest'})
        tlBtnsSuggest.staggerFromTo(".js-response-user", .3, {opacity:0, y: -10}, {opacity:1, y: 0}, 0.2);
        tlBtnsSuggest.play();
        this.elements.tchatFooter.find('.js-response-user').on('click', function(e) {
            e.preventDefault();
            // console.log('clicked')
            tlBtnsSuggest.reverse()
            var att = $(this).attr('data-response');
            // console.log('att', att)
            annyang.trigger(att);
    })
    }
    createResponseFromUser(message) {
         this.label_message = 'user';
         this.first_message = false;
         this.labels.asUserRequest = true;
         this.formatMessage(message[0])
         this.elements.area_message.append(this.tpl_message);
         this.messageAnimation();
         this.scrollTolastMessage()
         annyang.abort();

    }
    scrollTolastMessage() {
        let class_to_apply_scroll;
        $(window).width() < 993 ? class_to_apply_scroll = '.area-tchatbot-inner' : class_to_apply_scroll = '.area-tchatbot-inner';
        $(class_to_apply_scroll).stop().animate({
            scrollTop: $(class_to_apply_scroll)[0].scrollHeight
            // scrollTop: 99999999999999
        }, this.timerScroll);
    }
    createResponseFromBot(infoReponse, obj) {
        this.label_message = 'bot';
        this.first_message = false;
        this.labels.asUserRequest = false;
        let resultMessage = infoReponse.result;
        if(obj.redirect && obj.redirect === true) {
            window.location = resultMessage
        }
        else if(obj.html && obj.html === true) {

           this.elements.result_search.html('')
           this.elements.result_search.append(resultMessage)
           window.lazyLoadInstance.update();

        }
        else {
            this.formatMessage(resultMessage);
            this.elements.area_message.append(this.tpl_message);
            if(infoReponse.propositions && infoReponse.propositions.length > 0) {
                this.elements.tchatFooter.html('');
                this.createAndAttchPrompts(infoReponse.propositions)
            }
            this.messageAnimation()
            this.scrollTolastMessage()
        }
        annyang.start();

    }
    messageAnimation() {
        // console.log('this.elements.tchatbot_message[0]', this.elements.tchatbot_message[0])
        var elms = $('.tchatbot-message').not('.is-doing, .user-time-message')


        elms.each(function(i, el) {
            var markup = '';
            markup += '<div class="word">';
            var text = $(el).text()
            var classToApply = '';
            for (let index = 0; index < text.length; index++) {
                let elementChar = text[index];
                elementChar === ' ' ? classToApply = 'whitespace' : classToApply = 'normal-word'
                markup += '<div class="letter o-0 '+ classToApply +'">'+ elementChar +'</div>';
            }
            markup += '</div>';
            $(el).html(markup);
        })

        var userTime = $('.user-time-message').css({opacity: 1});
        var lastMessage = $('.tchatbot-message').not('.is-doing').not('.user-time-message')
        tlMessages.staggerFromTo(lastMessage, .3, {opacity:0, y: 20}, {opacity:1, y: 0}, 0.2, '+=0', addTextEffect(lastMessage));
        tlMessages.play();

        function addTextEffect(elm) {
            // console.log('test', elm)
            var tl = new TimelineMax({paused: true})
            tl.set(elm.find('.letter'), {opacity:0})
            tl.staggerTo(elm.find('.letter'),0.01, {opacity:1, ease:Power1.easeIn}, 0.02, "+=0.1", addClassTrans);
            tl.play();

            function addClassTrans() {
                $('.tchatbot-message').addClass('is-doing');
            }
        }
    }
    toggleTchatbotBox() {
        // console.log('called')
        this.toggleAnim();
    }
    openTchat() {
        tlBot.play();
    }
    closeTchat() {
        tlBot.reverse();
    }
    toggleAnim() {
        // console.log('called 2')
        if(this.labels.asUserRequest === true) {
            return;
        }
        tlBot.reversed() ? this.openTchat() : this.closeTchat()
    }
}

const BotTrocManager = new BotManager();

// console.log(BotTrocManager.elements.ui_skitt)

tlAnimPulse.fromTo(BotTrocManager.elements.ui_skitt, .6, {css: {boxShadow: '0 0 0 0 rgba(255, 237, 0, 0.7)'}, transform : 'scale(1.2) translateX(-50%)' }, {yoyo: true, css: {boxShadow: '0 0 0 15px rgba(255, 237, 0, 0)'}, transform : 'scale(1) translateX(-50%)'})
tlAnimPulse.play()
tlBot.to(BotTrocManager.elements.tchatbot_box, .2, {className: '+=is-expanded', onComplete: setDefaultMessageTrocBot});

function setDefaultMessageTrocBot() {
    var $first_message = $('.first-message');
    // console.log('this', this)
    // var $tpl_first = '<div style="opacity:0;" class="tchatbot-message bot first-message"></div>';
    BotTrocManager.formatMessage('Bonjour, je suis le bot de Troc, que souhaitez vous rechercher ?')
    if(BotTrocManager.first_message === true) {
        BotTrocManager.elements.area_message.append(BotTrocManager.tpl_message);
        // createTextEffect('.first-message');
        BotTrocManager.messageAnimation();
        BotTrocManager.first_message = false;
        BotTrocManager.createAndAttchPrompts(['Je veux acheter', 'Je veux vendre', 'Je recherche un magasin']);
        // tlMessages.staggerFromTo('.first-message', .3, {opacity:0, y: 10}, {opacity:1, y: 0}, 0.2);
        tlMessages.play();
        // base_int_process++;
    }
}
function trashBtns() {
            BotTrocManager.elements.tchatFooter.html('')
}
if($(window).width() < 993) {
    ficheTimeline.to('.sidebar-search .tab-content', .3, {className: '+=is-open', clearProps: 'all'});
    const maxTop = 0;
    const maxScrollForClose = 400;

    var win = $(window).height();

    var form = $('#js-form-search');

    console.log('win', win);
    // 35 = taille du du header du filtre
    // .100 = marge de securité pour le submit du formulaire
    form.css({
        'height' : win - 35 - 100,
    });

    form.on('submit', function() {
        let activeLink = $('.js-sidebar-search-link.active');
        activeLink.trigger('click')
        ficheTimeline.reverse();
    })


    $('.js-close-filtres').on('click', function(e) {
        e.preventDefault();
        let activeLink = $('.js-sidebar-search-link.active');
        activeLink.trigger('click')
        ficheTimeline.reverse();
        
    })

    interact('.sidebar-search .tab-content').draggable({
        startAxis: 'y',
        lockAxis: 'y',
        ignoreFrom: '[no-drag]'
    })
    .on('dragmove dragend', handleDragEvents)
    // .on('touchmove', handleTouchEvents)
    // function handleTouchEvents(event) {
    //     // console.log('touch', event)
    //     return false;
    // }   
    function handleDragEvents(event) {
        // console.log('log', event)
        // console.log('log', event.pageY)

        let posY = parseInt(event.pageY);

        let btn_search = $('.sidebar-search form .form-row:nth-child(8) .btn');
        let wave = $('#wave-anim')
        let skit = $('#skitt-ui')

        console.log('posY', posY)
        if(posY > maxTop) {
            $(event.target).css({
                'top': posY + 'px'
            })
            if(event.type != "dragend") {
                btn_search.css({
                    opacity : 1 - ( posY / 100 )
                })
                wave.css({
                    opacity : 1 - ( posY / 100 )
                })
                skit.css({
                    opacity : 1 - ( posY / 100 )
                })
            }
            else {
                btn_search.css({
                    opacity : 1
                }) 
                wave.css({
                    opacity : 1
                })
                skit.css({
                    opacity : 1
                })
            }
            
        }

        if(event.type === "dragend") {
            
            if(posY > maxScrollForClose) {
                ficheTimeline.reverse();
                let activeLink = $('.js-sidebar-search-link.active');
                activeLink.trigger('click')
            }
            else {
                ficheTimeline.play();
                $(event.target).css({
                    'top': ''
                })
            }

        }
        
    }
    // Not Work
    // Draggable.zIndex = 999999;
    // let debugDrag = Draggable.create('.sidebar-search .tab-content', {
    //     type: 'y',
    //     throwProps: false,
    //     zIndexBoost: true,
    //     lockAxis: true,
    //     inertia: false,
    //     // bounds: window,
    //     bounds: {target: window, minY: 0, maxY: 300},
    //     // autoScroll: 1,
    //     allowNativeTouchScrolling: true,
    //     dragClickables: true,
    //     onDrag: function(e) {
    //         // alert('drag')
    //     },  
    //     onDragEnd: function(e) {
    //         // console.log('this', this)
    //         // console.log('pageY round', Math.round(e.y))
    //         let maths = Math.round(e.y)
    //         //console.log('maths', maths)
    //         let direction = this.getDirection();
    
            
    //         // console.log('direction', direction)
    //         if(maths >= 300) {
    //             ficheTimeline.reverse();
    //             let activeLink = $('.js-sidebar-search-link.active');
    //             // console.log('activeLink', activeLink)
    //             activeLink.trigger('click')
    //         }
    //         else {
    //             ficheTimeline.play();
    //         }
    //     }
    // });
    // console.log(debugDrag.hitTest());
}



BotTrocManager.elements.tabsItems.on('click', function(e) {
    e.preventDefault();
    // alert('CLICKED');
    let the_data = $(this).attr('href');

    let $sidebarSearch = $('.sidebar-search');
    
    BotTrocManager.elements.tabsItems.not($(this)).removeClass('active');
    BotTrocManager.elements.tabsItemsPane.not($(the_data)).removeClass('active');

    let docWidth = $(window).width();
    
    if($(this).hasClass('active') == false) {
        $(this).addClass('active');
        $(the_data).addClass('active');
        if(docWidth < 993) {
            $sidebarSearch.addClass('is-expendable-mobile')
            ficheTimeline.play();
            $('body').addClass('body-lock');
        }
    }
    else {
        if(docWidth < 993) {
            $sidebarSearch.removeClass('is-expendable-mobile')
            $(this).removeClass('active');
            $(the_data).removeClass('active');
            ficheTimeline.reverse();
            $('body').removeClass('body-lock');
        }
    }

    if($(this).hasClass('active') && the_data == '#vocal') {
        BotTrocManager.openTchat();
        annyang.start();
    }
    if($(this).hasClass('active') == false && the_data == '#vocal') {
        BotTrocManager.closeTchat();
        annyang.abort();
    }
})

BotTrocManager.elements.ui_skitt.on('click', function(e) {
    e.preventDefault();

    tlAnimPulse.reversed() ? tlAnimPulse.play() : tlAnimPulse.pause()
    if(BotTrocManager.labels.asUserRequest === true) {
        // du click avant avant la fin de la réponse
        annyang.start();
    }

    if(BotTrocManager.elements.tchatbot_box.hasClass('is-expanded') == false) {
        BotTrocManager.openTchat();
    }

})






//console.log('BotTrocManager', BotTrocManager)
if($( window ).width() > 992) {
    //console.log(BotTrocManager.elements.tabsItems)
    BotTrocManager.elements.tabsItems.eq(0).click();
}

if(!annyang) {
    // console.log(BotTrocManager.elements.tabsItems.eq(1).parent().parent())
    BotTrocManager.elements.tabsItems.eq(1).parent().parent().addClass('is-full')
    BotTrocManager.elements.tabsItems.eq(1).parent().remove()
   
}

$('.js-close-tchatbot').on('click', function(e) {
    e.preventDefault();
    if($(window).width() < 768) {
        $('body').toggleClass('body-lock');
        // $('.expand-form').collapse('toggle');
    }
    closeTchatbot();
})

function closeTchatbot() {
    // setDefaultMessageTrocBot();
    annyang.abort();
    tlAnimPulse.reversed() ? tlAnimPulse.play() : tlAnimPulse.pause();

    BotTrocManager.toggleTchatbotBox()
}

if(annyang) {
    require('./bot-animations.js');
}

if(annyang) {
    annyang.addCallback('result', function(message) {

        //console.log('result from annyang', message)
    
        /**
         * On retire les timeout potentiellement en cours
         */
        for (var i = 0; i < runningSetTimeout.length; i++) {
            clearTimeout(runningSetTimeout[i]);
        }
        runningSetTimeout = [];
    
    
    
        var uri = "/ajax/bot?search-bot="+encodeURIComponent(message[0]);
        // console.log('BotTrocManager.labels.asUserRequest before user', BotTrocManager.labels.asUserRequest)
        BotTrocManager.createResponseFromUser(message);
        // console.log('BotTrocManager.labels.asUserRequest', BotTrocManager.labels.asUserRequest)
        $.ajax({
            type:'GET',
            url: uri,
            dataType: 'json'
        })
            .done(function(data) {
                /**
                 * Temporaire juste pour avoir les infos :
                 */
                //console.log('data.responses', data.responses)
    
    
                $.each(data.responses,function(key,infoReponse){
    
                    // console.log("infoReponse['delay']", infoReponse['delay'])
                    // console.log("infoReponse['delay'] typeof", typeof infoReponse['delay'])
                    if(infoReponse['delay'] !== undefined ){
                        //console.log('a')
                        runningSetTimeout.push(setTimeout(function () {
                            //console.log('delay called')
                            BotTrocManager.traiteReponse(infoReponse)
    
                        },infoReponse['delay'] * 1000));
                        //console.log(runningSetTimeout);
                    } else {
                        //console.log('b')
                        // BotManager.intTrashBtns = 1;
                        //console.log('normal state')
                        BotTrocManager.traiteReponse(infoReponse);
                    }
                })
                //processTchat(data);
            })
            .fail(function(jqXHR) {
                //console.log(jqXHR);
                //console.log("Une erreur est survenue...");
            });
    
    
    
    })
}


